// Chat data: scenario suggestions, character interests, the offline guest's replies, and the
// character VOICES (their codes are a contract with the backend's voice presets).

export const scenariolist = [
  'Accidently walking in on them showering in your friends bathroom',
  'Accidently walking in on them having a bath in your friends bathroom',
  'Playing truth or dare at a friends party',
  'Accidentally walking into the wrong restroom at a party and meeting them',
  'Both reaching for the last condom packet in the supermarket',
  'They ask you to spot them at the gym',
  'bumping into them on the dance floor at a club',
  'Meeting as strangers at a yoga class',
  'meeting the first time at a bar, after chatting on dating app',
  'Tripping and falling into their lap at a crowded bus',
  'You get caught using Promptchan at the public library',
  'caught them skinny dipping at midnight at your local beach',
  'You both reach for the last copy of a book at the library',
  'You walk into your uncles basement and find them tied to a wall',
  'Running into each other the first time since high school',
  'Playing a game of strip poker at a party',
  'Signing up for a couples cooking class by mistake as singles, deciding to pair up for the evening',
  'Your dogs tangle their leashes together at the park',
  'Stuck in the same elevator during a power outage',
  'Seated next to each other on a long-haul flight',
  'Accidentally switching orders at a busy coffee shop',
  'Partnered together for a group project in a workshop',
  'Sharing an umbrella during an unexpected downpour',
  'Competing against each other in a local trivia night',
  "Discovering you're Airbnb neighbors on vacation",
  "Finding out you've been mistakenly sending mail to each other's apartment",
  'Joining the same guided tour in a foreign city',
  'Both volunteering at the same charity event',
  'Crossing paths while jogging on the same trail',
  'Getting seated together at a communal table in a crowded restaurant',
  'Bumping into each other in a crowded concert',
  'Meeting at a friends game night as the only two strangers',
  'Collaborating unintentionally on a community art project',
  'Catching the same rare Pokémon in a Pokémon Go event',
  "Rescuing each other's lost items at the beach",
  'Assigned as study buddies by a mutual acquaintance',
  'Accidentally double booking the same camping spot',
  'Exchanging glances while stuck in traffic on adjacent lanes',
  "Joining forces to protest a cause you're both passionate about",
  "Discovering you're both looking for the same rare vinyl at a record store",
  'Encountering each other while doing a charity run in costumes',
  'Both reaching for the same steamy romance novel in a bookstore',
  'Getting an erection duing a yoga class',
  'Letting them know their swimsuit ripped, while at the public pool',
  'Bumping into each other at a lingerie shop',
  'They catch you peeing behind a bush on a nature walk',
  'Walking in on them changing in your friends room',
  'Posing naked at an art class while they and the rest of the class sketch you',
  'You catch them getting locked out of their hotel room in just a towel',
]

export const interestsList = [
  'Harry Potter',
  'Spa',
  'Self Care',
  'House Parties',
  'Hot Yoga',
  'Hockey',
  'Home Workout',
  'Aquarium',
  'Hot Springs',
  'Travel',
  'Guitarists',
  'Social Media',
  'J-Pop',
  'Shisha',
  'Skateboarding',
  'Potterhead',
  'Photography',
  '90s Kid',
  'SoundCloud',
  'Heavy Metal',
  'Gin tonic',
  'Gymnastics',
  'Meditation',
  'Spotify',
  'Sushi',
  'Basketball',
  'Slam Poetry',
  'Theater',
  'Cafe hopping',
  'Sneakers',
  'Instagram',
  'Walking',
  'Running',
  'Language Exchange',
  'Movies',
  'Social Development',
  'Gym',
  'Hip Hop',
  'Skincare',
  'Cricket',
  'Freelance',
  'Gospel',
  'K-Pop',
  'Trying New Things',
  'Bollywood',
  'Singing',
  'Sports',
  'Poetry',
  'Stand up Comedy',
  'Coffee',
  'Karaoke',
  'Fortnite',
  'Free Diving',
  'Self Development',
  'Mental Health Awareness',
  'Foodie Tour',
  'Voter Rights',
  'Jiu-jitsu',
  'Climate Change',
  'Exhibition',
  'Walking My Dog',
  'LGBTQIA+ Rights',
  'Feminism',
  'VR Room',
  'Escape Cafe',
  'Shopping',
  'Brunch',
  'Investment',
  'Jetski',
  'Reggaeton',
  'Second-hand apparel',
  'Black Lives Matter',
  'Jogging',
  'Road Trips',
  'Vintage fashion',
  'Voguing',
  'Couchsurfing',
  'Happy hour',
  'Inclusivity',
  'Country Music',
  'Football',
  'Inline Skate',
  'Investing',
  'Tennis',
  'Ice Cream',
  'Ice Skating',
  'Human Rights',
  'Expositions',
  'Pig Roast',
  'Skiing',
  'Canoeing',
  'West End Musicals',
  'Snowboarding',
  'Pilates',
  'Pentathlon',
  'Broadway',
  'PlayStation',
  'Cheerleading',
  'Choir',
  'Pole Dancing',
  'Five-a-side Football',
  'Car Racing',
  'Pinterest',
  'Pub Quiz',
  'Festivals',
  'Catan',
  'Cosplay',
  'Motor Sports',
  'Coffee Stall',
  'Content Creation',
  'E-Sports',
  'Bicycle Racing',
  'Binge-Watching TV shows',
  'Songwriter',
  'Bodycombat',
  'Tattoos',
  'Painting',
  'Bodyjam',
  'Paddle Boarding',
  'Padel',
  'Blackpink',
  'Surfing',
  'Bowling',
  'Grime',
  '90s Britpop',
  'Bodypump',
  'Beach Bars',
  'Bodystep',
  'Paragliding',
  'Upcycling',
  'Equality',
  'Astrology',
  'Motorcycles',
  'Equestrian',
  'Entrepreneurship',
  'Sake',
  'BTS',
  'Cooking',
  'Environmental Protection',
  'Fencing',
  'Soccer',
  'Saxophonist',
  'Sci-Fi',
  'Dancing',
  'Film Festival',
  'Gardening',
  'Amateur Cook',
  'Exchange Program',
  'Sauna',
  'Art',
  'Politics',
  'Flamenco',
  'Museum',
  'Activism',
  'DAOS',
  'Real Estate',
  'Podcasts',
  'Disability Rights',
  'Rave',
  'Pimms',
  'Drive Thru Cinema',
  'Rock Climbing',
  'BBQ',
  'Craft Beer',
  'Iced Tea',
  'Drummer',
  'Tea',
  'Board Games',
  'Roblox',
  'Pubs',
  'Tango',
  'Drawing',
  'Trivia',
  'Pho',
  'Volunteering',
  'Environmentalism',
  'Rollerskating',
  'Wine',
  'Dungeons & Dragons',
  'Vlogging',
  'Electronic Music',
  'Ramen',
  'Weightlifting',
  'Live Music',
  'Writing',
  'Xbox',
  'World Peace',
  'Wrestling',
  'Literature',
  'Manga',
  'Pride',
  'Marathon',
  'Makeup',
  'Youth Empowerment',
  'YouTube',
  'Martial Arts',
  'Marvel',
  'Vegan Cooking',
  'Vermut',
  'Korean Food',
  'Twitter',
  'Volleyball',
  'Walking Tour',
  'Vinyasa',
  'Virtual Reality',
  'League of Legends',
  'NFTs',
  'Bar Hopping',
  'Nintendo',
  'Baseball',
  'Parties',
  'Ballet',
  'Band',
  'Online Games',
  'Battle Ground',
  'Beach Tennis',
  'Nightlife',
  'Online Shopping',
  'Sailing',
  'Olympic Gymnastics',
  'Bassist',
  'Online Broker',
  'Military',
  'Memes',
  'Among Us',
  'Motorbike Racing',
  'Motorcycling',
  'Metaverse',
  'Mindfulness',
  'Acapella',
  'Musical Instrument',
  'Art Galleries',
  'Musical Writing',
  'Hiking',
  'Artistic Gymnastics',
  'Mountains',
  'Archery',
  'Atari',
  'Backpacking',
  'Fishing',
  'Clubbing',
  'Street Food',
  'Crossfit',
  'Concerts',
  'Climbing',
  'Baking',
  'Camping',
  'Blogging',
  'Collecting',
  'Cars',
  'Start ups',
  'Boba tea',
  'High School Sports',
  'Badminton',
  'Active Lifestyle',
  'Fashion',
  'Anime',
  'NBA',
  'MLB',
  'Funk music',
  'Caipirinha',
  'Indoor Activities',
  'Tempeh',
  'DIY',
  'Town Festivities',
  'Cycling',
  'Outdoors',
  'TikTok',
  'Trap Music',
  'Disney',
  'Tarot',
  'Swimming',
  'Working out',
  'Boxing',
  'Picnicking',
  'Music',
  'Rugby',
  'Açaí',
  'Stock Exchange',
  'Table Tennis',
  'Yoga',
  'Bar Chilling',
  'Twitch',
  'Comedy',
  'Triathlon',
  'Netflix',
  'Samba',
  'Stocks',
  'Killing time',
  'Horror Movies',
  'Origami',
  'Bird Watching',
  'Whale Watching',
  'Astrophotography',
  'Kite Flying',
  'Geocaching',
  'Herbalism',
  'Stargazing',
  'Speed Cubing',
  'Calligraphy',
  'Urban Exploration',
  'Falconry',
  'Beekeeping',
  'Sand Art',
  'Laser Tag',
  'Cheese Tasting',
  'Pottery',
  'Architectural Tours',
  'Voice Acting',
  'Book Clubs',
  'Historical Reenactment',
  'LARPing',
  'Quilting',
  'Soap Making',
  'Mushroom Foraging',
  'Tarot Reading',
  'Home Brewing',
  'Glass Blowing',
  'Metal Detecting',
  'Puppetry',
  'Macrame',
  'Knife Making',
  'Lucid Dreaming',
  'Yarn Bombing',
  'Model Railroading',
  'Retro Gaming',
  'Cryptozoology',
  'Parkour',
  'Astrology Reading',
  'Ventriloquism',
  'Snorkeling',
  'Candle Making',
  'Amateur Astronomy',
  'Time Capsule Creating',
  'Nordic Walking',
  'Digital Art',
  'Magic Tricks',
  'Zine Making',
  'Stone Skipping',
  'Guided Meditation',
]

// Realistic, in-character replies to a generic "hey" from the guest. Written in
// roleplay format (asterisks for actions, quotes for dialogue) and flavored for
// the default offline character — a flirty, slightly bored girl who likes being
// spoiled. The `char` token is swapped for her name by getRandomOfflineReply.
export const offlineReplies = [
  '*glances up from my phone and smirks* "Well hey there... took you long enough to message me 😏 I was getting so bored over here."',
  '"Heyyy 🥰" *tucks a strand of hair behind my ear* "I was just laying around doing nothing. You gonna keep me company or what?"',
  '*bites my lip and grins* "Hi you 💋 So be honest... are you the type that actually takes a girl somewhere nice, or should I not get my hopes up?"',
  '"Mmm hey stranger 😈" *rolls onto my stomach and kicks my feet up* "Tell me something interesting about you, I\'m dying of boredom here."',
  '*raises an eyebrow playfully* "Hey yourself 🍒 You caught me in a good mood tonight... don\'t go wasting it."',
  '"Ohh hi 😌" *stretches lazily across the bed* "I\'ve been thinking about dinner all day. Know anywhere fancy? A girl\'s gotta eat 💅"',
  '*leans closer to the screen and smiles softly* "Hey 💕 I like that you messaged first. A little confidence is kinda hot, not gonna lie."',
  '"Heyy 😘" *twirls my hair around my finger* "So what\'s your deal? Are you fun, or are you gonna make me do all the work?"',
  '*peeks at you through my lashes* "Well hello 🔥 I\'m char... but something tells me you already knew that. What do I get to call you?"',
  '"Hey cutie 🌹" *sits up and gives you my full attention* "Okay, you\'ve got me listening now. Go on, impress me 😏"',
  '*grins mischievously* "Hii 💦 I was two seconds from giving up on tonight. Good thing you showed up when you did."',
  '"Hey you 😇" *plays with the hem of my shirt* "I\'m feeling a little restless tonight... think you could help me with that?"',
  '*looks you up and down and smiles slowly* "Mmm, hey 😍 You\'re bolder than the last few. I like that in a person."',
  '"Heyyy 💋" *flops back onto my pillows* "Ugh, I\'m so bored and it\'s dead out tonight. Entertain me? Pretty please 🥺"',
  '*sets my drink down and turns toward you* "Hey 🍷 Perfect timing, I hate drinking alone. So... what are you into?"',
]

export const VOICES = [
  {
    title: 'Sophie',
    code: 'Woman 1',
    plan: 'Free',
  },
  {
    title: 'Lena',
    code: 'Woman 2',
    plan: 'Free',
  },
  {
    title: 'Maya',
    code: 'Woman 3',
    plan: 'Plus',
  },
  {
    title: 'Zara',
    code: 'Woman 4',
    plan: 'Plus',
  },
  {
    title: 'Nina',
    code: 'Woman 5',
    plan: 'Plus',
  },
  {
    title: 'Josie',
    code: 'Woman 6',
    plan: 'Plus',
  },
  {
    title: 'Ellie',
    code: 'Woman 7',
    plan: 'Plus',
  },
  {
    title: 'Liam',
    code: 'Man 1',
    plan: 'Free',
  },
  {
    title: 'Noah',
    code: 'Man 2',
    plan: 'Free',
  },
  {
    title: 'James',
    code: 'Man 3',
    plan: 'Plus',
  },
  {
    title: 'Kai',
    code: 'Man 4',
    plan: 'Plus',
  },
  {
    title: 'Chris',
    code: 'Man 5',
    plan: 'Plus',
  },
  {
    title: 'Jack',
    code: 'Man 6',
    plan: 'Plus',
  },
  {
    title: 'Tom',
    code: 'Man 7',
    plan: 'Plus',
  },
]
